import { CourseRequirementType } from '@/types/courses';

export const requirementLabels: Record<CourseRequirementType, string> = {
  [CourseRequirementType.watched_minute]: 'Watchtime',
  [CourseRequirementType.pulse_check]: 'Pulse check (deprecated)',
  [CourseRequirementType.quizzes_passed]: 'Quizzes passed',
  [CourseRequirementType.poll_submissions]: 'Poll submissions',
};

/** Requirement types an admin can add to a course. Pulse checks are deprecated and cannot be created. */
export const selectableRequirementTypes = [
  CourseRequirementType.watched_minute,
  CourseRequirementType.quizzes_passed,
  CourseRequirementType.poll_submissions,
] as const;

export const requirementDescription = (type: CourseRequirementType, requiredAmount: number | undefined) => {
  const amount = requiredAmount ?? 'x';
  const plural = requiredAmount === 1 ? '' : 's';

  switch (type) {
    case CourseRequirementType.watched_minute:
      return `Watch ${amount} minute${plural} to complete this requirement`;
    case CourseRequirementType.quizzes_passed:
      return `Pass ${amount} quiz${requiredAmount === 1 ? '' : 'zes'} to complete this requirement`;
    case CourseRequirementType.poll_submissions:
      return `Respond to ${amount} poll question${plural} to complete this requirement`;
    default:
      return `Demonstrate your engagement via ${amount} check-in${plural} (deprecated)`;
  }
};
